import request from '@/utils/request'

export function init(platformType) {
  return request({
    url: `/mg/mg-waimai-api/config/init/${platformType}`,
    method: 'put',
    data: {},
    loading: true,
  })
}

export function update(data) {
  return request({
    url: '/mg/mg-waimai-api/config/configSetting',
    method: 'post',
    data,
  })
}

export function updateSyncPriceConfig(data) {
  return request({
    url: '/mg/mg-waimai-api/config/priceConfigSetting',
    method: 'post',
    data,
  })
}




/**
 * 批量价格同步
 * @param {Object} data - { waimaiConfigId, pushPriceRatio }
 * @returns {Promise<{ totalCount, successCount, failCount, failDetails }>}
 */
export function batchPushPrice(data) {
  return request({
    url: '/mg/mg-waimai-api/config/batchPushPrice',
    method: 'post',
    data,
    timeout: 1000 * 60 * 30,
  })
}

//查询当前用户开了哪些外卖平台
export function queryUserOpenedPlatforms() {
  return request({
    url: '/mg/daohang-product-api/selectStoreByPos',
    method: 'get',
    loading: true,
  })
}